import React, { useState } from "react";
import { siteData } from "../mock";
import { Check, ArrowRight, Lock, PiggyBank } from "lucide-react";
import PackageCheckoutModal from "./PackageCheckoutModal";

export default function VirtualPrograms() {
  const { virtualPrograms } = siteData;
  const [selected, setSelected] = useState(null);

  const openCheckout = (p) => {
    const savingsNote = p.savings > 0 ? `SAVE $${p.savings} VS BUYING SEPARATELY` : null;
    setSelected({
      id: p.id,
      title: p.name,
      subtitle: p.description,
      price: p.price,
      priceNote: "one-time payment · lifetime access",
      savingsNote,
      requiredSessions: 1,
      sessionLabel: "kickoff call",
      eventTitle: "VIRTUAL KICKOFF CALL",
      eventDuration: "30 min",
      calendlyUrl: siteData.calendly.kickoff,
    });
  };

  const scrollToContact = () => {
    const el = document.querySelector("#contact");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="remote" className="relative bg-purple-band py-24">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="mb-2">
          <span className="deal-yellow font-heading font-semibold tracking-[0.3em] text-sm md:text-base">
            BRING THE HEAT WHEREVER YOU ARE
          </span>
        </div>
        <h2 className="font-display text-white font-bold text-5xl md:text-7xl tracking-wide mb-4">
          VIRTUAL COACHING
        </h2>
        <p className="text-white/70 text-lg mb-14">
          Train with purpose. See the results.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {virtualPrograms.map((p) => (
            <div
              key={p.id}
              className={`relative rounded-2xl p-8 hover-lift flex flex-col ${
                !p.available ? "card-surface opacity-80" : "card-surface"
              }`}
            >
              {p.tag && (
                <span className="absolute -top-3 right-6 px-3 py-1 text-[11px] tracking-[0.2em] font-bold rounded bg-[#e10600] text-[#0a0a0a]">
                  {p.tag}
                </span>
              )}
              <h3 className="font-display font-bold text-white text-3xl mb-3 tracking-wide">
                {p.name}
              </h3>
              <p className="text-white/75 mb-6 min-h-[3rem]">{p.description}</p>

              <div className="mb-6">
                {p.price !== null ? (
                  <>
                    <div className="flex items-baseline gap-2 flex-wrap">
                      <span className="font-display font-bold text-white text-5xl">${p.price}</span>
                      <span className="deal-yellow tracking-[0.2em] text-sm">USD</span>
                      {p.basePrice && p.basePrice > p.price && (
                        <span className="text-white/45 text-lg line-through">${p.basePrice}</span>
                      )}
                    </div>
                    {p.savings > 0 && (
                      <div className="mt-3 inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-emerald-500/12 text-emerald-400 border border-emerald-500/35 text-xs font-heading font-bold tracking-[0.15em]">
                        <PiggyBank size={14} strokeWidth={2.5} />
                        SAVE ${p.savings} VS BUYING SEPARATELY
                      </div>
                    )}
                  </>
                ) : (
                  <div className="flex items-center gap-2 text-white/60">
                    <Lock size={18} />
                    <span className="font-heading tracking-[0.2em] text-sm">COMING SOON</span>
                  </div>
                )}
              </div>

              <ul className="space-y-3 mb-8 flex-1">
                {p.features.map((f, i) => (
                  <li key={i} className="flex items-start gap-3 text-white/85 text-[15px]">
                    <Check size={18} className="deal-yellow shrink-0 mt-0.5" />
                    <span>{f}</span>
                  </li>
                ))}
              </ul>

              <button
                onClick={() => p.available && openCheckout(p)}
                disabled={!p.available}
                className={`mt-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md font-heading font-semibold tracking-[0.2em] text-sm transition-colors ${
                  p.available
                    ? "bg-[#e10600] text-[#0a0a0a] hover:bg-[#ff1a1a]"
                    : "bg-white/10 text-white/50 cursor-not-allowed"
                }`}
              >
                {p.available ? "SELECT" : "COMING SOON"}
                {p.available && <ArrowRight size={16} />}
              </button>
            </div>
          ))}
        </div>
      </div>

      <PackageCheckoutModal
        isOpen={selected !== null}
        onClose={() => setSelected(null)}
        item={selected}
      />
    </section>
  );
}
